/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckyWheel.vue?vue&type=template&id=abd3570a&scoped=true"
import script from "./luckyWheel.vue?vue&type=script&lang=js"
export * from "./luckyWheel.vue?vue&type=script&lang=js"
import style0 from "./luckyWheel.vue?vue&type=style&index=0&id=abd3570a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd3570a",
  null
  
)

export default component.exports